import { ImpactStatsSection } from "@/templates/sections/ImpactStatsSection"
import { getSectionVariant } from "./variants"
import { ImpactStatsInlineBand, ImpactStatsOversized, ImpactStatsCountUp } from "./impact_stats_variants"
import { wrapWithBackgroundIfNeeded, type BlockComponentProps } from "./shared"

/**
 * `cards` (default / unknown variant) is the original ImpactStatsSection,
 * unchanged for all existing sections. All layouts keep the shared
 * background-image wrapper so `content.background_image` behaves the same
 * regardless of variant.
 */
export function ImpactStatsBlock(props: BlockComponentProps) {
  const { content, customizations, styleOverrides } = props
  const inner = (() => {
    switch (getSectionVariant(content)) {
      case "inline-band":
        return <ImpactStatsInlineBand {...props} />
      case "oversized":
        return <ImpactStatsOversized {...props} />
      case "count-up":
        return <ImpactStatsCountUp {...props} />
      default:
        return <ImpactStatsSection content={content} customizations={customizations} styleOverrides={styleOverrides} />
    }
  })()
  return <>{wrapWithBackgroundIfNeeded(content, inner)}</>
}
